import React, { useState } from "react";
import Table from "../../../../../../../app/components/Table";
import { FiEye } from "react-icons/fi";
import BaseForm from "../../../../../../../app/components/BaseForm";

const EmailBox = () => {
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

   const data = [
    {
      id: 1,
      remetente: "comercial@empresa.com",
      card: "Abertura vendida",
      assunto: "Venda realizada com sucesso!",
      destinatarios: "Financeiro",
      template: "Template #01",
      status: "ativo",
      enviadoEm: "09/07/2025 10:00",
      corpoEmail: `
        <p>Olá,</p>
        <p>Foi realizado uma venda de abertura!</p>
        <br />
        <p>Cliente: <strong>{{Razão Social}}</strong></p>
        <p>CNPJ: <strong>{{CNPJ}}</strong></p>
        <p>Valor da abertura: <strong>{{Valor (R$)}}</strong></p>
        <br />
        <p>Financeiro, favor providenciar a cobrança da entrada de 50%</p>
        <br />
        <p>Atenciosamente,<br />Comercial</p>
      `,
      "Razão Social": "Empresa XPTO Ltda.",
      CNPJ: "12.345.678/0001-90",
      "Valor (R$)": "5.000,00",
    },
    {
      id: 2,
      remetente: "marketing@empresa.com",
      card: "Boas-vindas",
      assunto: "Bem-vindo à nossa plataforma!",
      destinatarios: "Clientes novos",
      template: "Template #02",
      status: "ativo",
      enviadoEm: "07/07/2025 08:40",
      corpoEmail: `
        <p>Olá <strong>{{Nome do cliente}}</strong>, seja bem-vindo!</p>
        <p>Estamos muito felizes em ter você conosco.</p>
      `,
      "Nome do cliente": "João Silva",
    },
    {
      id: 3,
      remetente: "suporte@empresa.com",
      card: "Confirmação",
      assunto: "Confirme seu cadastro",
      destinatarios: "Usuários pendentes",
      template: "Template #03",
      status: "inativo",
      enviadoEm: "05/07/2025 15:22",
      corpoEmail: `
        <p>Prezado <strong>{{Nome do cliente}}</strong>,</p>
        <p>Por favor, finalize seu cadastro para aproveitar todos os benefícios.</p>
      `,
      "Nome do cliente": "Maria Oliveira",
    },
  ];

  const columns = [
    { titulo: "Remetente", campo: "remetente" },
    { titulo: "Card", campo: "card" },
    { titulo: "Assunto", campo: "assunto" },
    { titulo: "Destinatários", campo: "destinatarios", apenasDesktop: true },
    { titulo: "Template", campo: "template", apenasDesktop: true },
    { titulo: "Status", campo: "status", tipo: "status", centralizado: true },
    { titulo: "Enviado em", campo: "enviadoEm" },
    { titulo: "Ações", campo: "acoes", tipo: "acoes", centralizado: true },
  ];

  const renderizarStatus = (status) => (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium ${
        status === "ativo"
          ? "bg-green-100 text-green-800"
          : "bg-red-100 text-red-800"
      }`}
    >
      {status === "ativo" ? "Ativo" : "Inativo"}
    </span>
  );

  const getCorpoComVariaveis = (template, dados) => {
    const mapa = {
      "Nome do cliente": dados.card,
      "Email do cliente": dados.remetente,
      "Assunto": dados.assunto,
      "Destinatários": dados.destinatarios,
      "Template": dados.template,
      "Status": dados.status,
      "Enviado em": dados.enviadoEm,
    };

    return template.replace(/{{(.*?)}}/g, (_, tag) => {
      const chave = tag.trim();
      return dados[chave] || mapa[chave] || `{{${chave}}}`;
    });
  };


  const handleVisualizar = (item) => {
    const corpoFinal = getCorpoComVariaveis(item.corpoEmail, item);
    setSelectedEmail({ ...item, corpoEmail: corpoFinal });
    setIsModalOpen(true);
  };

  const renderizarConteudo = (coluna, item) => {
    if (coluna.tipo === "status") return renderizarStatus(item[coluna.campo]);

    if (coluna.tipo === "acoes") {
      return (
        <div className="flex justify-center">
          <button
            className="text-gray-500 flex items-center justify-center h-6 w-6 rounded-full hover:bg-gray-100"
            onClick={(e) => {
              e.stopPropagation();
              handleVisualizar(item);
            }}
            title="Visualizar"
          >
            <FiEye className="text-gray-600 text-base" />
          </button>
        </div>
      );
    }

    return item[coluna.campo] || "—";
  };

  return (
    <>
      <Table
        colunas={columns}
        dados={data}
        renderizarStatus={renderizarStatus}
        renderizarConteudo={renderizarConteudo}
      />

      <BaseForm
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Visualizar Email"
        submitButtonText="Reenviar"
        cancelButtonText="Visualizar"
      >
        {selectedEmail && (
          <div className="bg-white p-4 rounded border max-w-full overflow-x-auto">
            <div
              dangerouslySetInnerHTML={{ __html: selectedEmail.corpoEmail }}
              className="prose max-w-none"
            />
          </div>
        )}
      </BaseForm>
    </>
  );
};

export default EmailBox;
